import { walkDagNodeIdsCertifiedLazy, walkDagNodeIdsPhaseCertifiedDifference, } from "@gitlode/internal-foundation/dag";
import { OrderedQueue } from "@gitlode/internal-foundation/support";
import { createCommitTimestampPhaseCertifiedStrategyOptions } from "./timestamp-frontier-policy.js";
export const DEFAULT_COMMIT_TRAVERSAL_STRATEGY = "certified-lazy";
export const EXPERIMENTAL_COMMIT_TRAVERSAL_ENV = "GITLODE_EXPERIMENTAL_COMMIT_TRAVERSAL";
const COMMIT_TRAVERSAL_STRATEGY_NAMES = [
    "certified-lazy",
    "phase-certified-fifo",
    "phase-certified-timestamp",
];
export function resolveCommitTraversalStrategyName(value) {
    if (value === undefined)
        return DEFAULT_COMMIT_TRAVERSAL_STRATEGY;
    if (isCommitTraversalStrategyName(value))
        return value;
    throw new Error(`Invalid ${EXPERIMENTAL_COMMIT_TRAVERSAL_ENV} value ${JSON.stringify(value)}. Expected one of: ${COMMIT_TRAVERSAL_STRATEGY_NAMES.join(", ")}.`);
}
export function createCommitTraversalStrategy(name) {
    switch (name) {
        case "certified-lazy":
            return {
                name,
                walk: (context, nodeId, excludeNodeId) => walkDagNodeIdsCertifiedLazy(context, nodeId, excludeNodeId, {
                    createFrontier: () => new OrderedQueue({
                        dequeueOrder: "lifo",
                        blockOrder: "preserve",
                    }),
                }),
            };
        case "phase-certified-fifo":
            return {
                name,
                walk: (context, nodeId, excludeNodeId) => walkDagNodeIdsPhaseCertifiedDifference(context, nodeId, excludeNodeId),
            };
        case "phase-certified-timestamp":
            return {
                name,
                walk: (context, nodeId, excludeNodeId) => walkDagNodeIdsPhaseCertifiedDifference(context, nodeId, excludeNodeId, createCommitTimestampPhaseCertifiedStrategyOptions()),
            };
    }
}
function isCommitTraversalStrategyName(value) {
    return COMMIT_TRAVERSAL_STRATEGY_NAMES.includes(value);
}
//# sourceMappingURL=strategy.js.map